export const SET_CURRENT_MENUS = 'menus/SET_CURRENT_MENUS_SUCCESS';
export const SET_CURRENT_MENUS_REQUEST = 'menus/SET_CURRENT_MENUS_REQUEST';
export const TOGGLE_MODAL = 'menus/TOGGLE_MODAL';
